<template>
  <v-row class="note" dense>
    <v-col cols="12">
      <div v-if="el.body">
        <div class="break-spaces" v-html="el.body"></div>
      </div>
      <!-- <pre>{{ flattenArray(attrs.listOne[0]) }}</pre> -->
      <v-row v-if="attrs.tags && attrs.listOne" dense>
        <v-col
          cols="4"
          v-for="item in attrs.listOne"
          :key="item.id"
          class="mt-1 my-0 py-0"
        >
          <p
            v-if="el[item.name] && el[item.name].length"
            class="mb-1 text-caption text-uppercase mt-2"
          >
            {{ item.title }}
          </p>
          <div class="d-flex flex-wrap">
            <div v-for="chip in el[item.name]" :key="chip">
              <v-chip
                small
                class="mr-1 mb-1 tag"
                v-if="
                  checkFromList(chip, flattenArray(item)) &&
                    getName(chip, flattenArray(item)) !== 'Deleted'
                "
                :style="{ borderColor: getColor(chip, flattenArray(item)) }"
              >
                {{ getName(chip, flattenArray(item)) }}
              </v-chip>
            </div>
          </div>
        </v-col>
      </v-row>

      <div v-if="el.linkedTo && el.linkedTo.length">
        <p class="mb-1 text-caption text-uppercase mt-2">
          Linked to
        </p>
        <v-chip small class="mr-1" v-for="tag in el.linkedTo" :key="tag.id">
          {{ getName(tag, attrs.listTwo) }}
        </v-chip>
      </div>
    </v-col>
  </v-row>
</template>

<script>
import { flattenArray } from "./model";

export default {
  name: "ColHeader",
  data() {
    return {
      flattenArray: flattenArray,
    };
  },
  methods: {
    getName(id, arr) {
      const item = arr.find((x) => x.id === id);
      return item ? item.name : "Deleted";
    },
    getColor(id, arr) {
      console.log("color arr", arr);
      const item = arr.find((x) => x.id === id);
      console.log("color item", item);
      return item ? item.color : "None";
    },
    checkFromList(id, arr) {
      const refList = arr.map((x) => x.id);
      return refList;
      // return refList.includes(id);
    },
  },
  props: {
    el: {
      required: true,
      type: Object,
      default: () => ({}),
    },
    attrs: {
      type: Object,
      default: () => ({}),
    },
  },
};
</script>

<style lang="scss">
.tag {
  background: white !important;
  border: 2px solid grey;
  color: black !important;
  margin: 2px;
}
</style>
